import {
  ColourMetrics,
  GroupedColourMetrics,
  KeysWithValsOfType
} from "../../../../pages/inSeasonReviewPage/hooks/useFetchColours";

/**
 * Groups flat colour metrics by their parent colour
 * and sum up the values.
 */
export function groupByColourParent(
  data: ColourMetrics[],
  sumKey: KeysWithValsOfType<ColourMetrics, number>
): GroupedColourMetrics[] {
  // Filter out items with null, undefined, zero, or negative values for the sumKey
  const validData = data.filter((item) => {
    const value = item[sumKey];
    return value != null && value > 0;
  });

  // Calculate total sum of the selected column (sumKey)
  const totalSum = validData.reduce((acc, item) => acc + item[sumKey], 0);

  return Object.entries(
    validData.reduce(
      (acc, item) => {
        const parent = item.parent || "Unknown";
        return { ...acc, [parent]: [...(acc[parent] || []), item] };
      },
      {} as Record<string, ColourMetrics[]>
    )
  ).map(([parent, values]) => {
    // Use reduce to achieve a single parse both preparing children
    // And computing ratio of total sum
    const [children, sum] = values.reduce(
      ([accChildren, accSum], child) => {
        return [
          [
            ...accChildren,
            {
              ...child,
              colour: child.style_colour_hex_code,
              name: child.style_colour_hex_code,
              value: child[sumKey],
              ratio: totalSum ? (child[sumKey] || 0) / totalSum : 0
            }
          ],
          accSum + (child[sumKey] || 0)
        ];
      },
      [[] as GroupedColourMetrics["children"], 0]
    );

    return {
      name: parent,
      colour: parent,
      value: sum,
      ratio: totalSum ? sum / totalSum : 0,
      children
    } as GroupedColourMetrics;
  });
}
